import { Brand } from 'app/model';
import { HistoryResponse } from 'app/model/history-response';

import { RestfulApiService } from '../restful-api.service';

export class BrandHistoryService extends RestfulApiService<HistoryResponse, Brand> {
    protected getFormName(): string {
        throw new Error('Method not implemented.');
    }
    protected getPath(parent: Brand): string {
        return `brands/${parent.id}/attrs/history`;
    }
}
export const brandHistoryService = new BrandHistoryService();
